import {Button, Stack, Typography, useTheme} from '@mui/material';
import React, {Fragment} from 'react';

import {AlertModal} from 'presentation/components';
import {usePersonalData} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {formatMasks, formatText} from 'presentation/utils';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ConfirmContactInfoDialogProps} from './types';

const {confirmModalHeader, cancelSelection, confirmSelection, confirmModalTitle} =
	translations['pt-br'].privateFlow.bookingFlow.confirmModalSelection;

export function ConfirmContactInfoDialog({
	onPrimaryAction,
	onSecondaryAction,
	open,
	setOpen,
}: ConfirmContactInfoDialogProps) {
	const theme = useTheme();
	const {userName, currentPhone, currentEmail} = usePersonalData();

	return (
		<AlertModal
			variant="primary"
			customIconName="person-filled"
			headerTitle={confirmModalHeader}
			title={confirmModalTitle}
			open={open}
			onClose={() => setOpen(false)}
			subDescription={
				<Fragment>
					<Typography color="text.primary">{formatText(userName)}</Typography>
					<Stack flexDirection="row" gap={1} alignItems="center">
						<Icon name="phone-android-filled" color={theme.palette.primary.main} />
						<Typography variant="h6" color="primary">
							{formatMasks('phone', currentPhone)}
						</Typography>
					</Stack>

					<Stack flexDirection="row" gap={1} alignItems="center">
						<Icon name="mail-filled" color={theme.palette.primary.main} />
						<Typography variant="h6" color="primary">
							{currentEmail}
						</Typography>
					</Stack>
				</Fragment>
			}
			footerContent={
				<Stack gap={1} width="100%">
					<Button
						type="submit"
						size="large"
						data-test="confirm-new-contact"
						onClick={onPrimaryAction}
						fullWidth
						data-tag-id={AppointmentBookingEnum.CONFIRMOU_INFORMACOES}>
						{confirmSelection}
					</Button>
					<Button
						data-tag-id={AppointmentBookingEnum.IR_PARA_MEU_PERFIL}
						fullWidth
						variant="outlined"
						onClick={onSecondaryAction}
						size="large">
						{cancelSelection}
					</Button>
				</Stack>
			}
		/>
	);
}
